import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputTextBook";
import InputDecimal from "../../helpers/InputDecimal";
import InputTextArea from "../../helpers/InputTextArea";
import InputTextAreaRadio from "../../helpers/InputTextAreaRadio";
import InputChecbox from "../../helpers/InputCheckbox";

import book_ok from "../../book/smile.png";
import book_neutral from "../../book/neutral.png";
import book_bad from "../../book/sad.png";

import isbad from "../../book/isbad.png";
import isok from "../../book/isok.png";

import t36 from "../../book/t36.png";
import t36plus from "../../book/t36plus.png";
import t38 from "../../book/t38.png";

function BookKid(props)
{   

    
    
    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [kids, setKids] = useState(props.kid);  //z info od serwera..
    const [refresh, setRefresh] = useState(props.refresh);  //z info od serwera..

    
    console.log(props);

    const [params, setParams] = useState(props.params);
    const [title, setTitle] = useState(props.title);
    
   
    const ChangeBookValue = (e) => {
    
        var typ    = e.target.getAttribute('atr-typ');   
        var value    = e.target.getAttribute('atr-value');   
        var id    = e.target.getAttribute('atr-dziecko-id');   
    
        //filedName, val, correct, msg
        props.valChange(typ,value,id);

    }
    
    const valChangeListener = (id,typ, val) => {
        
        props.valChange(typ,val,id);
     }



    const closeDialog = () => {       
        props.onBack('link');
        
    }

    const saveData = () => {


                

        const sendData = {
            data: kids,
            typ: '',
        }

             
        props.mainView.setProgress(-2);
        

        fetch( Config.url + '/rest_v1_employessModule,emp_add_dzienniczek_group', {
            method: 'POST', 
            body: JSON.stringify(sendData), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Dane zostały zapisane", "ok" , null);         
                        
                        //getTab();
                        //Config.removeFromBuffer( Config.cache_kids_search, props.userData );                        
                      
                        props.onBack();
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }

    var is_mobile = props.mainView.isMobile();

    if(is_mobile)
    {
        var mobile_table = 'mobile_table';
        var mobile_tb = 'mobile_tb';
        var dlg_type = 'dlg_window dlg_type_xxx shadowx';
    }
    else
    {
        var mobile_table = 'book_table_stac';
        var mobile_tb = 'book_tb';
        var dlg_type = 'dlg_window dlg_type_book shadowx';
    }

    return (

        <div className={dlg_type} >

            <div className="dlg_title">
                {title}
            </div>

            <div className={"dlg_content_x "+mobile_table} >
                <div className={mobile_tb}>
            {
                            kids.map( (dziecko, ix2) => {

                                var is_selected_good='';
                                var is_selected_ok='';
                                var is_selected_bad='';

                                var sniadanie_1_good = '';
                                var sniadanie_1_ok = '';
                                var sniadanie_1_bad = '';
                                if(dziecko.dziennik.sniadanie_1=='1') sniadanie_1_good='book_face_selected'; //zjedzony w calosci
                                if(dziecko.dziennik.sniadanie_1=='3') sniadanie_1_ok='book_face_selected'; //tak sobie..
                                if(dziecko.dziennik.sniadanie_1=='2') sniadanie_1_bad='book_face_selected'; //niejedzony

                                var sniadanie_2_good = '';
                                var sniadanie_2_ok = '';
                                var sniadanie_2_bad = '';
                                if(dziecko.dziennik.sniadanie_2=='1') sniadanie_2_good='book_face_selected'; //zjedzony w calosci
                                if(dziecko.dziennik.sniadanie_2=='3') sniadanie_2_ok='book_face_selected'; //tak sobie
                                if(dziecko.dziennik.sniadanie_2=='2') sniadanie_2_bad='book_face_selected'; //niezjedzone

                                var obiad_posilek_1_good = '';
                                var obiad_posilek_1_ok = '';
                                var obiad_posilek_1_bad = '';
                                if(dziecko.dziennik.obiad_danie_1=='1') obiad_posilek_1_good='book_face_selected'; //zjedzone
                                if(dziecko.dziennik.obiad_danie_1=='3') obiad_posilek_1_ok='book_face_selected'; //taksobie
                                if(dziecko.dziennik.obiad_danie_1=='2') obiad_posilek_1_bad='book_face_selected'; //niejzedzone

                                var obiad_posilek_2_good = '';
                                var obiad_posilek_2_ok = '';
                                var obiad_posilek_2_bad = '';
                                if(dziecko.dziennik.obiad_danie_2=='1') obiad_posilek_2_good='book_face_selected';
                                if(dziecko.dziennik.obiad_danie_2=='3') obiad_posilek_2_ok='book_face_selected';
                                if(dziecko.dziennik.obiad_danie_2=='2') obiad_posilek_2_bad='book_face_selected';

                                var podwieczorek_good = '';
                                var podwieczorek_ok = '';
                                var podwieczorek_bad = '';
                                if(dziecko.dziennik.podwieczorek=='1') podwieczorek_good='book_face_selected';
                                if(dziecko.dziennik.podwieczorek=='3') podwieczorek_ok='book_face_selected';
                                if(dziecko.dziennik.podwieczorek=='2') podwieczorek_bad='book_face_selected';

                                
                                var praca_z_ksiazka_good = '';
                                var praca_z_ksiazka_ok = '';
                                var praca_z_ksiazka_bad = '';
                                if(dziecko.dziennik.praca_z_ksiazka=='3') praca_z_ksiazka_good='book_face_selected';
                                if(dziecko.dziennik.praca_z_ksiazka=='2') praca_z_ksiazka_ok='book_face_selected';
                                if(dziecko.dziennik.praca_z_ksiazka=='1') praca_z_ksiazka_bad='book_face_selected';
                                
                                var prace_plastyczne_good = '';
                                var prace_plastyczne_ok = '';
                                var prace_plastyczne_bad = '';
                                if(dziecko.dziennik.prace_plastyczne=='3') prace_plastyczne_good='book_face_selected';
                                if(dziecko.dziennik.prace_plastyczne=='2') prace_plastyczne_ok='book_face_selected';
                                if(dziecko.dziennik.prace_plastyczne=='1') prace_plastyczne_bad='book_face_selected';

                                var praca_w_grupie_good = '';
                                var praca_w_grupie_ok = '';
                                var praca_w_grupie_bad = '';
                                if(dziecko.dziennik.praca_w_grupie=='3') praca_w_grupie_good='book_face_selected';
                                if(dziecko.dziennik.praca_w_grupie=='2') praca_w_grupie_ok='book_face_selected';
                                if(dziecko.dziennik.praca_w_grupie=='1') praca_w_grupie_bad='book_face_selected';

                                var jezyk_obcy_good = '';
                                var jezyk_obcy_ok = '';
                                var jezyk_obcy_bad = '';
                                if(dziecko.dziennik.jezyk_obcy=='3') jezyk_obcy_good='book_face_selected';
                                if(dziecko.dziennik.jezyk_obcy=='2') jezyk_obcy_ok='book_face_selected';
                                if(dziecko.dziennik.jezyk_obcy=='1') jezyk_obcy_bad='book_face_selected';
                                



                                var spacer_good = '';
                                var spacer_ok = '';
                                var spacer_bad = '';
                                if(dziecko.dziennik.spacer=='1') spacer_good='book_face_selected'; //byslismy                                
                                if(dziecko.dziennik.spacer=='2') spacer_bad='book_face_selected'; //nie bylismy

                                var plac_zabaw_good = '';
                                var plac_zabaw_ok = '';
                                var plac_zabaw_bad = '';
                                if(dziecko.dziennik.plac_zabaw=='1') plac_zabaw_good='book_face_selected'; //bylismy                 
                                if(dziecko.dziennik.plac_zabaw=='2') plac_zabaw_bad='book_face_selected'; //niebylismy

                                var sen_good = '';
                                var sen_ok = '';
                                var sen_bad = '';
                                if(dziecko.dziennik.sen=='1') sen_good='book_face_selected'; //dzemka zaliczona                       
                                if(dziecko.dziennik.sen=='2') sen_bad='book_face_selected'; //brak dzemki
                                
                                var kupka_good = '';
                                var kupka_ok = '';
                                var kupka_bad = '';
                                if(dziecko.dziennik.kupka=='1') kupka_good='book_face_selected'; //byla               
                                if(dziecko.dziennik.kupka=='2') kupka_bad='book_face_selected'; //nie byla


                                
                                var temperatura_good = '';
                                var temperatura_ok = '';
                                var temperatura_bad = '';
                                if(dziecko.dziennik.temperatura=='0') temperatura_good='book_face_selected'; //brak informacji
                                if(dziecko.dziennik.temperatura=='1') temperatura_ok='book_face_selected'; //temperatura podwyzoszona
                                if(dziecko.dziennik.temperatura=='2') temperatura_bad='book_face_selected'; // znaczonac podwyzszona..

                                var kaszel_good = '';
                                var kaszel_ok = '';
                                var kaszel_bad = '';
                                if(dziecko.dziennik.kaszel=='0') kaszel_good='book_face_selected'; //brak info
                                if(dziecko.dziennik.kaszel=='2') kaszel_ok='book_face_selected'; // brak kaszlu
                                if(dziecko.dziennik.kaszel=='1') kaszel_bad='book_face_selected';// kaszel..

                                var katar_good = '';
                                var katar_ok = '';
                                var katar_bad = '';
                                if(dziecko.dziennik.katar=='0') katar_good='book_face_selected'; //brak info
                                if(dziecko.dziennik.katar=='2') katar_ok='book_face_selected'; //brak kataru
                                if(dziecko.dziennik.katar=='1') katar_bad='book_face_selected';  // wystepuje kaszel..

                                var ocena_good = '';
                                var ocena_ok = '';
                                var ocena_bad = '';
                                if(dziecko.dziennik.ocena=='3') ocena_good='book_face_selected';
                                if(dziecko.dziennik.ocena=='2') ocena_ok='book_face_selected';
                                if(dziecko.dziennik.ocena=='1') ocena_bad='book_face_selected';

                                    
                                    return <div>
                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Pierwsze śniadanie
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+sniadanie_1_good} onClick={ChangeBookValue} atr-typ='sniadanie_1' atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                <div><img src={book_neutral} className={'book_face book_face_ok book '+sniadanie_1_ok} title="ok"  onClick={ChangeBookValue} atr-typ='sniadanie_1' atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+sniadanie_1_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='sniadanie_1' atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                            </div>
                                        </div>
                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Drugie śniadanie
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+sniadanie_2_good} onClick={ChangeBookValue} atr-typ='sniadanie_2' atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                <div><img src={book_neutral} className={'book_face book_face_ok book '+sniadanie_2_ok} title="ok"  onClick={ChangeBookValue} atr-typ='sniadanie_2' atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+sniadanie_2_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='sniadanie_2' atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                            </div>
                                        </div>
                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Obiad pierwszy posiłek
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+obiad_posilek_1_good} onClick={ChangeBookValue} atr-typ='obiad_danie_1' atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                <div><img src={book_neutral} className={'book_face book_face_ok book '+obiad_posilek_1_ok} title="ok"  onClick={ChangeBookValue} atr-typ='obiad_danie_1' atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+obiad_posilek_1_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='obiad_danie_1' atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                            </div>
                                        </div>
                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Obiad drugi posiłek
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+obiad_posilek_2_good} onClick={ChangeBookValue} atr-typ='obiad_danie_2' atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                <div><img src={book_neutral} className={'book_face book_face_ok book '+obiad_posilek_2_ok} title="ok"  onClick={ChangeBookValue} atr-typ='obiad_danie_2' atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+obiad_posilek_2_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='obiad_danie_2' atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                            </div>
                                        </div>
                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Podwieczorek
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+podwieczorek_good} onClick={ChangeBookValue} atr-typ='podwieczorek' atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                <div><img src={book_neutral} className={'book_face book_face_ok book '+podwieczorek_ok} title="ok"  onClick={ChangeBookValue} atr-typ='podwieczorek' atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+podwieczorek_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='podwieczorek' atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                            </div>
                                        </div>
                                        <br></br>
                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Praca z książką
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+praca_z_ksiazka_good} onClick={ChangeBookValue} atr-typ='praca_z_ksiazka' atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                <div><img src={book_neutral} className={'book_face book_face_ok book '+praca_z_ksiazka_ok} title="ok"  onClick={ChangeBookValue} atr-typ='praca_z_ksiazka' atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+praca_z_ksiazka_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='praca_z_ksiazka' atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                            </div>
                                        </div>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Prace plastyczne
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+prace_plastyczne_good} onClick={ChangeBookValue} atr-typ='prace_plastyczne' atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                <div><img src={book_neutral} className={'book_face book_face_ok book '+prace_plastyczne_ok} title="ok"  onClick={ChangeBookValue} atr-typ='prace_plastyczne' atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+prace_plastyczne_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='prace_plastyczne' atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                            </div>
                                        </div>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Praca w grupie
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+praca_w_grupie_good} onClick={ChangeBookValue} atr-typ='praca_w_grupie' atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                <div><img src={book_neutral} className={'book_face book_face_ok book '+praca_w_grupie_ok} title="ok"  onClick={ChangeBookValue} atr-typ='praca_w_grupie' atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+praca_w_grupie_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='praca_w_grupie' atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                            </div>
                                        </div>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Poznana litera
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face book_row_text'  v="show" id={dziecko.id}>
                                                <InputText  userData={props.userData} value={dziecko.dziennik.nowa_litera} err='' kid={dziecko.id}  valChange={valChangeListener} goNext='' name="nowa_litera" placeholder={"Poznana litera:"} className=' w200 ' req='0'  />   
                                            </div>
                                        </div>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Uwagi logopedy
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face book_row_text'  v="show" id={dziecko.id}>
                                                <InputText  userData={props.userData} value={dziecko.dziennik.logopeda_uwagi} err='' kid={dziecko.id}  valChange={valChangeListener} goNext='' name="logopeda_uwagi" placeholder={"Uwagi:"} className=' w200 ' req='0'  />   
                                            </div>
                                        </div>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Język obcy
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+jezyk_obcy_good} onClick={ChangeBookValue} atr-typ='jezyk_obcy' atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                <div><img src={book_neutral} className={'book_face book_face_ok book '+jezyk_obcy_ok} title="ok"  onClick={ChangeBookValue} atr-typ='jezyk_obcy' atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+jezyk_obcy_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='jezyk_obcy' atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                            </div>
                                        </div>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Temat zajęć
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face book_row_text'  v="show" id={dziecko.id}>
                                                <InputText  userData={props.userData} value={dziecko.dziennik.jezyk_obcy_temat_zajec} err='' kid={dziecko.id}  valChange={valChangeListener} goNext='' name="jezyk_obcy_temat_zajec" placeholder={"Temat zajęć:"} className=' w200 ' req='0'  />   
                                            </div>
                                        </div>

                                        <br></br>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Wyjście na spacer
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+spacer_good} onClick={ChangeBookValue} atr-typ='spacer' atr-value='1' atr-dziecko-id={dziecko.id}  title="Dziecko było na spacerze"/></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+spacer_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='spacer' atr-value='2' atr-dziecko-id={dziecko.id} title="Dziecko nie było na spacerze"/></div>
                                            </div>
                                        </div>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Wyjście na plac zabaw
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+plac_zabaw_good} onClick={ChangeBookValue} atr-typ='plac_zabaw' atr-value='1' atr-dziecko-id={dziecko.id}  title="Dziecko było na placu zabaw"/></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+plac_zabaw_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='plac_zabaw' atr-value='2' atr-dziecko-id={dziecko.id} title="Dziecko nie było na placu zabaw"/></div>
                                            </div>
                                        </div>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Drzemka / Sen
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+sen_good} onClick={ChangeBookValue} atr-typ='sen' atr-value='1' atr-dziecko-id={dziecko.id}  title="Dżemka zaliczona"/></div> 
                                                <div><img src={book_bad} className={'book_face book_face_bad '+sen_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='sen' atr-value='2' atr-dziecko-id={dziecko.id} title="Bram dżemki"/></div>
                                            </div>
                                        </div>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                WC / Kupka
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+kupka_good} onClick={ChangeBookValue} atr-typ='kupka' atr-value='1' atr-dziecko-id={dziecko.id}  title="Kupka - Tak"/></div> 
                                                <div><img src={book_bad} className={'book_face book_face_bad '+kupka_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='kupka' atr-value='2' atr-dziecko-id={dziecko.id} title="Kupka -NIE"/></div>
                                            </div>
                                        </div>

                                        <br></br>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Gorączka
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={t36} className={"book_face book_face_good "+temperatura_good} onClick={ChangeBookValue} atr-typ='temperatura' atr-value='0' atr-dziecko-id={dziecko.id}  title="Dobrze, w normie"/></div>
                                                <div><img src={t36plus} className={'book_face book_face_ok book '+temperatura_ok} title="ok"  onClick={ChangeBookValue} atr-typ='temperatura' atr-value='1' atr-dziecko-id={dziecko.id} title="Podwyższona temperatura"/></div>
                                                <div><img src={t38} className={'book_face book_face_bad '+temperatura_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='temperatura' atr-value='2' atr-dziecko-id={dziecko.id} tilte="Temperatura znaczoąco podwyższona"/></div>
                                            </div>
                                        </div>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Kaszel
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={isok} className={"book_face book_face_good "+kaszel_good} onClick={ChangeBookValue} atr-typ='kaszel' atr-value='0' atr-dziecko-id={dziecko.id}  title="Brak kaszlu, brak informacji"/></div>                                             
                                                <div><img src={isbad} className={'book_face book_face_bad '+kaszel_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='kaszel' atr-value='1' atr-dziecko-id={dziecko.id} title="Występuje kaszel"/></div>
                                            </div>
                                        </div>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Katar
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={isok} className={"book_face book_face_good "+katar_good} onClick={ChangeBookValue} atr-typ='katar' atr-value='0' atr-dziecko-id={dziecko.id}  title="Brak kataru, brak informacji"/></div>                                           
                                                <div><img src={isbad} className={'book_face book_face_bad '+katar_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='katar' atr-value='1' atr-dziecko-id={dziecko.id} title="Katar"/></div>
                                            </div>
                                        </div>

                                        <br></br>

                                        <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_65'>
                                                Ocena
                                            </div>
                                            
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+ocena_good} onClick={ChangeBookValue} atr-typ='ocena' atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                <div><img src={book_neutral} className={'book_face book_face_ok book '+ocena_ok} title="ok"  onClick={ChangeBookValue} atr-typ='ocena' atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+ocena_bad} title="Źle"  onClick={ChangeBookValue} atr-typ='ocena' atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                            </div>
                                        </div>

                                    </div>



                                     /* 
                                    if(dziecko.dziennik.sniadanie_1=='3') is_selected_good='book_face_selected';
                                    if(dziecko.dziennik.sniadanie_1=='2') is_selected_ok='book_face_selected';
                                    if(dziecko.dziennik.sniadanie_1=='1') is_selected_bad='book_face_selected';
                                    if(dziecko.dziennik.sniadanie_1=='0') is_selected_good='book_face_selected';

                                    return <div className='kid_row'>
                                        <div className='kid_row_cell link_normal item_5'>
                                            Pierwsze śniadanie
                                        </div>
                                        <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>

                                       
                                        <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                            <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                            <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                            <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                        </div>
                                    </div>
                                

                                      
                                        if(dziecko.dziennik.sniadanie_2=='3') is_selected_good='book_face_selected';
                                        if(dziecko.dziennik.sniadanie_2=='2') is_selected_ok='book_face_selected';
                                        if(dziecko.dziennik.sniadanie_2=='1') is_selected_bad='book_face_selected';
                                        if(dziecko.dziennik.sniadanie_2=='0') is_selected_good='book_face_selected';
        
                                        return <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_5'>
                                                {ix2+1}.
                                            </div>
                                            <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                                <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                    <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                    <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                    <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                                </div>
                                            </div>
                                 
                                    if(dziecko.dziennik.obiad_danie_1=='3') is_selected_good='book_face_selected';
                                    if(dziecko.dziennik.obiad_danie_1=='2') is_selected_ok='book_face_selected';
                                    if(dziecko.dziennik.obiad_danie_1=='1') is_selected_bad='book_face_selected';
                                    if(dziecko.dziennik.obiad_danie_1=='0') is_selected_good='book_face_selected';
    
                                    return <div className='kid_row'>
                                        <div className='kid_row_cell link_normal item_5'>
                                            {ix2+1}.
                                        </div>
                                        <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                            </div>
                                        </div>
                                
                                        if(dziecko.dziennik.obiad_danie_2=='3') is_selected_good='book_face_selected';
                                        if(dziecko.dziennik.obiad_danie_2=='2') is_selected_ok='book_face_selected';
                                        if(dziecko.dziennik.obiad_danie_2=='1') is_selected_bad='book_face_selected';
                                        if(dziecko.dziennik.obiad_danie_2=='0') is_selected_good='book_face_selected';
        
                                        return <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_5'>
                                                {ix2+1}.
                                            </div>
                                            <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                                <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                    <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                    <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                    <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                                </div>
                                            </div>
                                 
                                        if(dziecko.dziennik.podwieczorek=='3') is_selected_good='book_face_selected';
                                        if(dziecko.dziennik.podwieczorek=='2') is_selected_ok='book_face_selected';
                                        if(dziecko.dziennik.podwieczorek=='1') is_selected_bad='book_face_selected';
                                        if(dziecko.dziennik.podwieczorek=='0') is_selected_good='book_face_selected';
        
                                        return <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_5'>
                                                {ix2+1}.
                                            </div>
                                            <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                                <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                    <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                    <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                    <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                                </div>
                                            </div>
                                      
                                        if(dziecko.dziennik.spacer=='3') is_selected_good='book_face_selected';
                                        if(dziecko.dziennik.spacer=='2') is_selected_ok='book_face_selected';
                                        if(dziecko.dziennik.spacer=='1') is_selected_bad='book_face_selected';
                                        if(dziecko.dziennik.spacer=='0') is_selected_good='book_face_selected';
        
                                        return <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_5'>
                                                {ix2+1}.
                                            </div>
                                            <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                                <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                    <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                    <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                    <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                                </div>
                                            </div>
                                     
                                        if(dziecko.dziennik.plac_zabaw=='3') is_selected_good='book_face_selected';
                                        if(dziecko.dziennik.plac_zabaw=='2') is_selected_ok='book_face_selected';
                                        if(dziecko.dziennik.plac_zabaw=='1') is_selected_bad='book_face_selected';
                                        if(dziecko.dziennik.plac_zabaw=='0') is_selected_good='book_face_selected';
        
                                        return <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_5'>
                                                {ix2+1}.
                                            </div>
                                            <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                                <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                    <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                    <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                    <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                                </div>
                                            </div>
                                    
                                        if(dziecko.dziennik.sen=='3') is_selected_good='book_face_selected';
                                        if(dziecko.dziennik.sen=='2') is_selected_ok='book_face_selected';
                                        if(dziecko.dziennik.sen=='1') is_selected_bad='book_face_selected';
                                        if(dziecko.dziennik.sen=='0') is_selected_good='book_face_selected';
        
                                        return <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_5'>
                                                {ix2+1}.
                                            </div>
                                            <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                                <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                    <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                    <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id} /></div>
                                                    <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}/></div>
                                                </div>
                                            </div>
                               */
                                    
                                    })
                        }  
                        </div>
            
                
                    <div className="eForm"> 
                        <div className="form_btn">
                            <div className="btn" onClick={saveData}  > Zapisz </div>
                            <div className="btn btn_back" onClick={closeDialog}    > Anuluj</div>
                        </div>
                    </div>    
            </div>

           

        </div>

    )

}


export default BookKid;


